import React, { Component } from 'react';
import qs from 'qs';
import { fetchAllSimoDevices } from 'api';
import { BIG_PAGE_SIZE } from '../constants';

const withSimoDevicesForCreateSub = (DecoratedComponent) => {
  class WithSimoDevicesForCreateSub extends Component {
    state = {
      simoDevices: [],
      simoDevicesLoading: false,
    };

    componentDidMount() {
      this.fetchDevices();
    }

    fetchDevices = () => {
      const { userId, location } = this.props;
      const { search } = location;
      const { device_id, device_sn } = qs.parse(search, {
        ignoreQueryPrefix: true,
      });
      if (!device_id || !device_sn) {
        this.setState({ simoDevicesLoading: true });
        fetchAllSimoDevices({
          user_profile: userId,
          simo_status: 'active',
          page_size: BIG_PAGE_SIZE,
        })
          .then((res) => {
            this.setState({
              simoDevices: res.data.results,
              simoDevicesCount: res.data.count,
            });
          })
          .finally(() => {
            this.setState({ simoDevicesLoading: false });
          });
      }
    };

    render() {
      const { children, ...props } = this.props;
      const { simoDevices, simoDevicesCount, simoDevicesLoading } = this.state;
      const childProps = {
        simoDevices,
        simoDevicesCount,
        simoDevicesLoading,
        ...props,
      };
      return React.createElement(DecoratedComponent, childProps, children);
    }
  }

  return WithSimoDevicesForCreateSub;
};

export default withSimoDevicesForCreateSub;
